import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme: any) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  sideLine: {
    width: '100%',
    height: 2,
    background: theme.palette.brand.greyLight2,
  },
  text: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
  },
}));

interface Props {
  text?: React.ReactNode;
  margin?: number;
}

export default function TextDivider({ text = 'or', margin = 1.5 }: Props) {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <div
      className={classes.container}
      style={{
        marginTop: theme.spacing(margin),
        marginBottom: theme.spacing(margin),
      }}
    >
      <div className={classes.sideLine} />
      <Typography className={classes.text}>{text}</Typography>
      <div className={classes.sideLine} />
    </div>
  );
}
